import InformativeCalculation from "@views/app/informative-calculation/informative-calculation.vue";

export const informativeCalculationRoutes = [
    {
        component: InformativeCalculation,
        name: "izracun_obrokov",
        path: "izracun-obrokov",
        meta: {
            buttons: [
                { name: "Print", action: "printCalculation", visible: true },
            ]
        }
    },
];